import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_CONFIG from './config';
import Logo from './components/Logo';

const VerifyPage = () => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Get phone number from session storage
    const storedPhoneNumber = sessionStorage.getItem('phoneNumber');
    if (!storedPhoneNumber) {
      // If no phone number, redirect back to login
      navigate('/');
      return;
    }
    setPhoneNumber(storedPhoneNumber);
  }, [navigate]);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Basic OTP validation
    if (!otp || otp.length !== 6) {
      setError('Please enter a valid 6-digit code');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.VERIFY_OTP}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phoneNumber: phoneNumber,
          otp: otp
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Store authentication token if provided
        if (data.token) {
          sessionStorage.setItem('authToken', data.token);
        }
        // Clear phone number from session storage
        sessionStorage.removeItem('phoneNumber');
        navigate('/chat');
      } else {
        setError(data.message || 'Invalid verification code');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
      console.error('Verification error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.REQUEST_OTP}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phoneNumber: phoneNumber
        })
      });

      if (response.ok) {
        setError(''); // Clear any existing errors
        // You might want to show a success message here
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to resend verification code');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
          <Logo size="large" showText={true} variant="dark" />
        </div>
        <h2>Verify Your Phone</h2>
        <p>A verification code has been sent to {phoneNumber}</p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleVerify}>
          <div className="input-group">
            <label htmlFor="otp">Verification Code</label>
            <input
              id="otp"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter 6-digit code"
              maxLength="6"
              required
              disabled={loading}
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Verifying...' : 'Verify Code'}
          </button>
        </form>
        <div className="resend-section">
          <p>Didn't receive the code?</p>
          <button 
            type="button" 
            className="resend-button" 
            onClick={handleResendCode}
            disabled={loading}
          >
            Resend Code
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyPage; 